// import { Route } from "react-router-dom";
// import Idcard from "../pages/landing/idcard";
import { Route } from "react-router-dom";
import React from "react";
import Gs1Product from "../pages/gs1Product";
import Scanner from "../pages/scanner";

const CustomPrivateRoute = () => [
  // <Route key="id-card" path="/my-id-card/:event/:slug" element={<Idcard />} />, // Add the custom redirect route here
  <Route key="scanner" path="/scanner" element={<Scanner />} />,
  <Route key="gs1-product" path="/01/:gtin" element={<Gs1Product />} />, // GS1 Digital Link resolver page (also reachable when logged in)
];
export default CustomPrivateRoute;
